import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { EVENTS_DATA_LOCKER_DEFAULT_COLUMNS } from '@/consts/dataLocker/events';

const eventsDataDefaultColumnsAtom = atom(async () => [...EVENTS_DATA_LOCKER_DEFAULT_COLUMNS]);
export const unwrappedEventsDataDefaultColumnsAtom = unwrap(eventsDataDefaultColumnsAtom, prev => prev || []);
